<div class="page-content page-fill">
  @for (item of announcements; track item) {
    <div>
      <h2>{{item.messageName}}</h2>
      <a [routerLink]="" (click)="getAnnouncementSheet(item)" >{{item.name}}</a>
    </div>
  }
</div>
